import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <Header />
      <main>
        <section className="relative bg-slate-900 py-24">
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-800" />
          <div className="container mx-auto px-4 relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">私隱政策</h1>
            <p className="text-slate-300 text-lg max-w-2xl">金晉物業代理有限公司（Marveland Property Agency Limited）</p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4 max-w-4xl">
            <div className="prose prose-slate max-w-none">
              <p className="text-sm text-slate-500 mb-8">最後更新日期：2026年8月13日</p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">1. 引言</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                金晉物業代理有限公司（下稱「本公司」、「我們」）尊重並致力保護您的個人資料私隱。本私隱政策說明我們如何收集、使用、披露及保護您的個人資料，並符合香港《個人資料（私隱）條例》（第486章）（下稱「條例」）的要求。
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                當您使用本網站（marveland.hk）或我們的服務時，即表示您同意本私隱政策的內容。如果您不同意本政策，請勿使用本網站或我們的服務。
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">2. 我們收集的個人資料</h2>
              <p className="text-slate-600 leading-relaxed mb-4">我們可能收集以下類型的個人資料：</p>
              <ul className="list-disc list-inside text-slate-600 space-y-2 mb-4">
                <li><strong>聯絡資料</strong>：姓名、電話號碼、電郵地址、通訊地址。</li>
                <li><strong>物業資料</strong>：您委託我們放售或放租的物業資料（例如地址、面積、售價、租金、照片）。</li>
                <li><strong>查詢資料</strong>：您透過本網站、WhatsApp、電話或電郵向我們查詢的內容。</li>
                <li><strong>技術資料</strong>：IP 地址、瀏覽器類型、操作系統、瀏覽記錄（透過 cookies 或類似技術）。</li>
                <li><strong>交易資料</strong>：與物業交易相關的資料（例如成交價、佣金、付款記錄）。</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">3. 收集個人資料的目的</h2>
              <p className="text-slate-600 leading-relaxed mb-4">我們收集您的個人資料用於以下目的：</p>
              <ul className="list-disc list-inside text-slate-600 space-y-2 mb-4">
                <li>提供物業代理服務（例如放售、放租、睇樓、成交）。</li>
                <li>回應您的查詢和提供客戶服務。</li>
                <li>向您發送物業資訊、市場分析、推廣訊息（如您同意）。</li>
                <li>改善本網站的功能和用戶體驗。</li>
                <li>遵守法律和監管要求。</li>
                <li>內部記錄和數據分析。</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">4. 個人資料的披露</h2>
              <p className="text-slate-600 leading-relaxed mb-4">我們不會出售、出租或交易您的個人資料。我們可能在以下情況下披露您的個人資料：</p>
              <ul className="list-disc list-inside text-slate-600 space-y-2 mb-4">
                <li><strong>服務提供者</strong>：協助我們提供服務的第三方（例如律師、銀行、測量師、IT 服務供應商）。</li>
                <li><strong>潛在買家/租客</strong>：如您委託我們放售或放租物業，我們可能向潛在買家或租客披露相關資料。</li>
                <li><strong>法律要求</strong>：如法律、法庭命令或監管機構要求，我們可能披露您的個人資料。</li>
                <li><strong>業務轉讓</strong>：如本公司進行合併、收購或資產轉讓，您的個人資料可能轉移給相關方。</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">5. 個人資料的保留</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                我們只會在達到收集目的所需的時間內保留您的個人資料。一般來說：
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-2 mb-4">
                <li>查詢資料：保留 12 個月。</li>
                <li>物業委託資料：保留至委託結束後 7 年（符合法律要求）。</li>
                <li>交易資料：保留至交易完成後 7 年（符合法律要求）。</li>
                <li>技術資料：保留 24 個月。</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">6. 個人資料的安全</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                我們採取適當的技術和組織措施保護您的個人資料，防止未經授權的存取、使用、披露、修改或銷毀。這些措施包括：
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-2 mb-4">
                <li>使用 SSL/TLS 加密技術保護資料傳輸。</li>
                <li>限制員工存取個人資料的權限。</li>
                <li>定期審查和更新安全措施。</li>
                <li>使用安全的雲端儲存服務（Cloudflare）。</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">7. Cookies 和類似技術</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                本網站使用 cookies 和類似技術（例如 Google Analytics）收集技術資料，以改善用戶體驗和分析網站流量。您可以透過瀏覽器設定拒絕 cookies，但這可能影響本網站的某些功能。
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">8. 第三方連結</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                本網站可能包含第三方網站的連結（例如 Facebook、Instagram、WhatsApp）。我們不對這些網站的私隱政策或內容負責。建議您查閱這些網站的私隱政策。
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">9. 您的權利</h2>
              <p className="text-slate-600 leading-relaxed mb-4">根據條例，您有權：</p>
              <ul className="list-disc list-inside text-slate-600 space-y-2 mb-4">
                <li>查閱我們持有的您的個人資料。</li>
                <li>要求更正不準確的個人資料。</li>
                <li>要求刪除您的個人資料（在法律允許的範圍內）。</li>
                <li>反對我們使用您的個人資料作直接促銷用途。</li>
                <li>撤回您之前給予的同意。</li>
              </ul>
              <p className="text-slate-600 leading-relaxed mb-4">
                如您想行使上述權利，請透過以下方式聯絡我們：
              </p>
              <ul className="list-none text-slate-600 space-y-2 mb-4">
                <li><strong>電話</strong>：(852) 3619 9530</li>
                <li><strong>WhatsApp</strong>：(852) 9236 8966</li>
                <li><strong>電郵</strong>：info@marveland.hk</li>
                <li><strong>地址</strong>：新界葵涌葵昌路58-70號永祥工業大廈2樓 A7-A8室</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">10. 直接促銷</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                如您同意，我們可能使用您的個人資料向您發送物業資訊、市場分析、推廣訊息。您可以隨時透過以下方式拒絕接收這些訊息：
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-2 mb-4">
                <li>點擊訊息中的「取消訂閱」連結。</li>
                <li>聯絡我們要求停止發送。</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">11. 未成年人</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                本網站和我們的服務不針對 18 歲以下的未成年人。我們不會故意收集未成年人的個人資料。如我們發現收集了未成年人的個人資料，會立即刪除。
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">12. 政策更新</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                我們可能不時更新本私隱政策。更新後的政策會在本網站發佈，並註明「最後更新日期」。建議您定期查閱本政策。
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">13. 聯絡我們</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                如您對本私隱政策有任何疑問、意見或投訴，請透過以下方式聯絡我們：
              </p>
              <ul className="list-none text-slate-600 space-y-2 mb-4">
                <li><strong>公司名稱</strong>：金晉物業代理有限公司（Marveland Property Agency Limited）</li>
                <li><strong>電話</strong>：(852) 3619 9530</li>
                <li><strong>WhatsApp</strong>：(852) 9236 8966</li>
                <li><strong>電郵</strong>：info@marveland.hk</li>
                <li><strong>地址</strong>：新界葵涌葵昌路58-70號永祥工業大廈2樓 A7-A8室</li>
              </ul>
              <p className="text-slate-600 leading-relaxed mb-4">
                您也可以向香港個人資料私隱專員公署投訴：
              </p>
              <ul className="list-none text-slate-600 space-y-2 mb-4">
                <li><strong>電話</strong>：(852) 2827 2827</li>
                <li><strong>電郵</strong>：communications@pcpd.org.hk</li>
                <li><strong>地址</strong>：香港灣仔皇后大道東248號大新金融中心13樓1303室</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
